import { Component, Event, EventEmitter, State, h } from '@stencil/core';
import store from '../../../helpers/store';
import { FlowStatus } from '../../../models/FlowStatus';
import { FlowSteps } from '../../../models/FlowSteps';
import { MobileOS } from '../../../models/IDevice';
import { BaseComponent } from '../../base-component';
import { Translations } from '../../../helpers/TranslationUtils';
import { TranslationValues } from '../../../models/ITranslationValues';
import { EctData } from '../../../helpers/EctDb';

// @ts-ignore
import loaderImg from '../../../assets/loader.svg';
import icoCamera from '../../../assets/landing/ico-camera.svg';
import logoOntrace from '../../../assets/logo-ontrace.svg';
import icoInfo from '../../../assets/ico-info.svg';
import icoClose from '../../../assets/ico-close.svg';
import { db } from '../../../helpers/db';

@Component({
  tag: 'camera-error',
  styleUrl: 'camera-error.css',
  shadow: false,
})
export class CameraError {
  @State() private title: string;
  @State() private description: string;
  @State() private info: string;
  @State() private modal: boolean;
  @State() private infoTitle: string;
  @State() private buttonDisabled: boolean;
  @State() private demoVideo: HTMLVideoElement;
  private buttonText: string;
  private translations: TranslationValues;
  private ectData: EctData;

  @Event({
    eventName: 'apiError',
  })
  apiErrorEvent: EventEmitter<any>;

  constructor() {}

  async componentWillLoad() {
    this.translations = await Translations.getValues();
    this.modal = false;
    this.buttonDisabled = false;
    this.title = this.translations.CameraErrorValues.Title;
    this.description = this.translations.CameraErrorValues.Description;
    this.info = this.translations.CameraErrorValues.Info;
    this.infoTitle = this.translations.CameraErrorValues.InfoTitle;
    this.buttonText = this.translations.CameraErrorValues.Button;

    this.ectData = await db.ectdata.get(store.requestId);
  }

  async componentDidLoad() {
    await BaseComponent.initialize(FlowSteps.CameraError);

    if (store.device.os.name != MobileOS.iOS && store.device.os.name != MobileOS.MacOS) {
      this.demoVideo.src = this.translations.CameraErrorValues.HowToLink;
      this.demoVideo.loop = true;
      this.demoVideo.play();
    } else {
      if (this.ectData.refreshStarted) {
        this.ectData.refreshStarted = false;
        await db.ectdata.put(this.ectData);
        store.flowStatus = FlowStatus.LANDING;
      }
    }
  }

  async disconnectedCallback() {
    await BaseComponent.finalize(FlowSteps.CameraError);
  }

  async infoClick() {
    this.modal = true;
  }

  async buttonClick() {
    this.buttonDisabled = true;
    if (store.device.os.name == MobileOS.iOS || store.device.os.name == MobileOS.MacOS) {
      this.ectData.refreshStarted = true;
      await db.ectdata.put(this.ectData);
      window.location.reload();
    } else {
      store.flowStatus = FlowStatus.LANDING;
    }
  }

  render() {
    return (
      <div class="container flex center">
        <div hidden={!this.modal} class="modal flex center w-100">
          <div class="inner w-100 text-center mx-1">
            <img class="close-modal" src={icoClose} onClick={() => (this.modal = false)}></img>
            <img src={icoInfo}></img>
            <h2 class="loud-text color-blue mb-1">
              <strong>{this.infoTitle}</strong>
            </h2>
            <video id="howtoPermissions" class="video-demo" playsinline ref={el => (this.demoVideo = el)}>
              <source type="video/mp4"></source>
            </video>
          </div>
        </div>

        <div class="px-3 text-center">
          <img class="mb-1 ml-1" src={icoCamera}></img>
          <h1 class="color-red mb-2">{this.title}</h1>
          <div class="color-blue mb-2 loud-text" innerHTML={this.description}></div>

          <p hidden={store.device.os.name == MobileOS.iOS || store.device.os.name == MobileOS.MacOS} class="flex center mb-3" onClick={() => this.infoClick()}>
            <strong class="color-blue loud-text">{this.info}</strong> &nbsp;&nbsp;
            <img src={icoInfo}></img>
          </p>

          <div class="button flex">
            {this.buttonDisabled ? (
              <div class="img-loader img-loader-button">
                <img class="loading-image loading-image-button" src={loaderImg}></img>
              </div>
            ) : null}
            <button class="main-button" type="button" disabled={this.buttonDisabled} onClick={() => this.buttonClick()}>
              {this.buttonText}
            </button>
          </div>
          <div class="footer text-center">
            <img src={logoOntrace}></img>
          </div>
        </div>
      </div>
    );
  }
}
